import { useLocation } from "react-router";

export default function useQueryParams(param) {
  const search = useLocation().search;
  const urlSearchParams = new URLSearchParams(search);
  const urlParam = urlSearchParams.get(param);

  return urlParam;
}
